import { createSelector } from 'reselect';
import { RESPONSE_META } from '../actions/constantsActions';
import { GetRegion } from '../constants';
import _ from 'lodash';
import { getRegion } from './selectors/user';

const initialState = {
  metadata: {},
};

export default function metadata(state = initialState, action) {
  if (action.type === RESPONSE_META) {
    return action.metadata;
  }
  return state;
}

const getFromStateChannelUnavailableFilter = state =>
  JSON.parse(state.metadata.filter_unavailable_channels || '{}');

export const getChannelUnavailableFilter = createSelector(
  getFromStateChannelUnavailableFilter,
  filters => filters[GetRegion()] || filters.default,
);

const getFromStateProvidersLabelConfig = state =>
  JSON.parse(state.metadata.providers_label_configuration || '{}');

export const getProvidersLabelConfig = createSelector(
  getFromStateProvidersLabelConfig,
  providers => providers[GetRegion()] || providers.default,
);

export const getMetadataState = state => _.get(state, 'metadata');

export const getCybersourceConfig = createSelector(
  [getMetadataState],
  metadataState => {
    const options = _.get(metadataState, 'cybersource_configuration', false);

    return JSON.parse(options) || {};
  },
);

export const getFilterListConfiguration = createSelector(
  [getRegion, getMetadataState],
  (region, metadataState) => {
    const options = JSON.parse(
      _.get(metadataState, 'byr_filterlist_configuration', '{}'),
    );

    const filterlist = _.get(options, [region, 'filterlist'], '');
    return filterlist;
  },
);
